import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/MainPage/Header/Header';
import Home from './components/MainPage/Home/Home';
import Products from './components/MainPage/Unique/Products';
import Contacts from './components/Contact';
import './App.css';
import Footer from './components/MainPage/Footer/Footer';
import Video from './components/MainPage/Videos/Video';
import Services from './components/MainPage/Services/Services';
import About from './components/company/About/About';
import Partner from './components/partners/Partner';
import Team from './components/company/Team/Team';
import Ventilation from './components/Offerings/Ventilation/Ventilation';
import ServiceRequestForm from './components/Service/ServiceRequest';
import EnergySystem from './components/Offerings/EnergySystems/EnergySystem';
import StorageSolution from './components/Offerings/StorageSolutions/StorageSolution';
import Chatbot from './components/chatbot/Chatbot';
import Career from './components/Careers/Career';
import JobDetails from './components/Careers/JobDetails';

function ScrollToTop() {
  const location = useLocation();

  React.useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Content />
    </Router>
  );
}

function Content() {
  const location = useLocation();

  return (
    <>
      <Header />
      <Routes>
        <Route path="/company/about" element={<About />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/partners" element={<Partner />} />
        <Route path="/company/team" element={<Team />} />
        <Route path="/offerings/ventilation" element={<Ventilation />} />
        <Route path="/offerings/energysystem" element={<EnergySystem />} />
        <Route path="/offerings/storagesolution" element={<StorageSolution />} />
        <Route path="/service-request" element={<ServiceRequestForm />} />
        <Route path="/career" element={<Career />} />
        <Route path="/job/:id" element={<JobDetails />} />
        <Route
          path="/"
          element={
            <div className="content">
              <div id="home"><Home /></div>
              <div id="product"><Products /></div>
              <div id="videos"><Video /></div>
              <div id="services"><Services /></div>
            </div>
          }
        />
      </Routes>

      <Footer />
      {/* The Chatbot is now shown on every page */}
      <Chatbot />
    </>
  );
}

export default App;
